export const DEFAULT_ACTION = "app/SubmittedCases/DEFAULT_ACTION";
export const CASEUPDATE = "app/SubmittedCases/CASEUPDATE";